import ElementContentAboutUs from '@/components/sections/builder/elements/body/about-us/content';
import ElementSettingAboutUs from '@/components/sections/builder/elements/body/about-us/setting';
import { AboutUsElementDataType } from '@/components/sections/builder/elements/body/about-us/type';
import { BetweenHorizontalStart } from 'lucide-react';

import AboutUsDescription from '@/components/sections/builder/elements/body/about-us/description';
import AboutUsButton from '@/components/sections/builder/elements/body/about-us/button';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';

const defaultData: AboutUsElementDataType = {
  name: 'About Us',
  colorSchemeSection: DEFAULT_THEME_COLOR_SCHEME,
  padding: {
    top: 20,
    bottom: 20,
    left: 0,
    right: 0,
  },
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const AboutUs = {
  type: 'about_us',
  group: 'body_about_us',
  defaultData,
  Element: ElementContentAboutUs,
  Setting: ElementSettingAboutUs,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [AboutUsDescription, AboutUsButton],
  childs: [AboutUsDescription, AboutUsButton],
  maxEntries: 1,
};

export default AboutUs;
